
export default function BrandsSection() {
  const brands = [
    {
      name: "McDonald's",
      logo: "https://public.readdy.ai/ai/img_res/65ce08d3f7a661e485f814681a88c232.jpg"
    },
    {
      name: "Cheddar's Scratch Kitchen",
      logo: "https://static.readdy.ai/image/7e30e953bcb98024829bc0b49eccc224/9c28b77e4200a0fbe49b876691a52bb6.png"
    },
    {
      name: "Urban Air Adventure Park",
      logo: "https://static.readdy.ai/image/7e30e953bcb98024829bc0b49eccc224/9eb67403d6f61f07213030ffad1d02f0.jfif"
    },
    {
      name: "National Football Foundation",
      logo: "https://static.readdy.ai/image/7e30e953bcb98024829bc0b49eccc224/c554d330087bcc008037016e01d95e1e.jfif"
    },
    {
      name: "Jack Black Skincare",
      logo: "https://static.readdy.ai/image/7e30e953bcb98024829bc0b49eccc224/9932223f17dba59955a15c223cc5dd38.png"
    },
    {
      name: "Cacique Foods",
      logo: "https://static.readdy.ai/image/7e30e953bcb98024829bc0b49eccc224/8530804ef299b9cd3008f3cc002ffbae.jfif"
    },
    {
      name: "Mission Tortillas",
      logo: "https://static.readdy.ai/image/7e30e953bcb98024829bc0b49eccc224/d62064462d88d672d3d1dd33534e91a1.png"
    },
    {
      name: "Visit California",
      logo: "https://readdy.ai/api/search-image?query=Visit%20California%20official%20tourism%20logo%20in%20black%20and%20white%20monochrome%20design%20on%20clean%20white%20background%2C%20California%20state%20tourism%20brand%20identity%2C%20professional%20minimalist%20logo%20presentation%20for%20portfolio%20showcase%2C%20simple%20clean%20branding&width=120&height=80&seq=visit-california-logo-bw&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Trusted by Leading Brands
          </h2>
          <div className="w-16 h-1 bg-blue-600 mx-auto"></div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-8 items-center">
          {brands.map((brand, index) => (
            <div key={index} className="flex items-center justify-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 group">
              <img 
                src={brand.logo}
                alt={`${brand.name} logo`}
                className={`max-w-full ${brand.name === 'Visit California' ? 'h-16' : 'h-12'} object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
